import { ComponentProps, forwardRef, ForwardedRef } from 'react';
import AntdTooltip from 'antd/es/tooltip';

function Tooltip(props: ComponentProps<typeof AntdTooltip>, ref: ForwardedRef<HTMLElement>) {
    return <AntdTooltip ref={ref} {...props} />;
}

Tooltip.displayName = 'Tooltip';

// @ts-ignore
export default forwardRef(Tooltip);
